// Routes
import config from '~/config';

// Pages
import Cart from '~/pages/Cart';
import ChangePass from '~/pages/ChangePass';
import CheckOutComboService from '~/pages/CheckOutComboService';
import CheckOutOrder from '~/pages/CheckOutOrder';
import ComboServiceDetail from '~/pages/ComboServiceDetail';
import Contact from '~/pages/Contact';
import CreateSchedulePage from '~/pages/CreateSchedule';
import DetailBooking from '~/pages/DetailBooking';
import DetailOrder from '~/pages/DetailOrder';
import DoubleCheckOutComboService from '~/pages/DoubleCheckOutComboService';
import DoubleCheckOutOrder from '~/pages/DoubleCheckOutOrder';
import DoubleSchedule from '~/pages/DoubleSchedule';
import EditProfile from '~/pages/EditProfile';
import ForgotPassword from '~/pages/ForgotPassword';
import HistoryBooking from '~/pages/HistoryBooking';
import HistoryOrder from '~/pages/HistoryOrder';
import HistoryTopUp from '~/pages/HistoryTopUp';
import HistoryWithdraw from '~/pages/HistoryWithdraw';
import Home from '~/pages/Home';
import Login from '~/pages/Login';
import MyCard from '~/pages/MyCard';
import MyUseCard from '~/pages/MyUseCard';
import MyUseCardDetail from '~/pages/MyUseCardDetail';
import ProductDetail from '~/pages/ProductDetail';
import ProductsFilter from '~/pages/ProductsFilter';
import Products from '~/pages/Products';
import Profile from '~/pages/Profile';
import Register from '~/pages/Register';
import Spa from '~/pages/Spa';
import SpaDetail from '~/pages/SpaDetail';
import TopUp from '~/pages/TopUp';
import Withdraw from '~/pages/Withdraw';
import ReceiveRewarded from '~/pages/ReceiveRewarded';
import DownLineCollab from '~/pages/DownLineCollab';
import ShareCollab from '~/pages/ShareCollab';
import Policy from '~/pages/Policy';
import NotificationPage from '~/pages/NotificationPage';
import TopUpDetail from '~/pages/TopUpDetail';
import DownloadAPP from '~/pages/DownloadAPP';
import MiddleSharePage from '~/pages/MiddleSharePage';
import VoucherDetail from '~/pages/VoucherDetail';
import PageNotFound from '~/pages/PageNotFound';
import PostDetail from '~/pages/PostDetail';
import PolicyPost from '~/pages/PolicyPost';
import PersonalPage from '~/pages/PersonalPage';
import ScanQR from '~/pages/ScanQR';
import NotiDetail from '~/pages/NotiDetail';
import HistoryUseCard from '~/pages/HistoryUseCard';
import SpaFilter from '~/pages/SpaFilter';

// Public routes
const publicRoutes = [
    { path: config.routes.home, component: Home, tabIndex: 0 },
    { path: config.routes.login, component: Login },
    { path: config.routes.register, component: Register },
    { path: config.routes.forgotPassword, component: ForgotPassword },
    { path: config.routes.contact, component: Contact },
    { path: config.routes.spa, component: Spa },
    { path: config.routes.spaFilter, component: SpaFilter },
    { path: config.routes.spaDetail, component: SpaDetail },
    // { path: config.routes.comboServiceDetail, component: ComboServiceDetail },
    { path: config.routes.createSchedulePage, component: CreateSchedulePage },
    { path: config.routes.createSchedulePageDetail, component: CreateSchedulePage },
    { path: config.routes.doubleSchedule, component: DoubleSchedule },
    { path: config.routes.products, component: Products },
    { path: config.routes.productDetail, component: ProductDetail },
    { path: config.routes.productsFilter, component: ProductsFilter },
    { path: config.routes.receiveRewarded, component: ReceiveRewarded },
    // { path: config.routes.policy, component: Policy },
    { path: config.routes.downloadAPP, component: DownloadAPP },
    { path: config.routes.middleShare, component: MiddleSharePage },
    { path: config.routes.topUp, component: TopUp },
    { path: config.routes.topUpDetail, component: TopUpDetail },
    { path: config.routes.policyPost, component: PolicyPost },
    // { path: config.routes.notification, component: NotificationPage },
    { path: config.routes.scan, component: ScanQR },
    { path: config.routes.cart, component: Cart },

    //PageNotFound
    { path: config.routes.pageNotFound, component: PageNotFound, layout: null },
];

const privateRoutes = [
    { path: config.routes.voucherDetail, component: VoucherDetail },
    // { path: config.routes.topUp, component: TopUp },
    { path: config.routes.withdraw, component: Withdraw },
    { path: config.routes.historyTopUp, component: HistoryTopUp },
    { path: config.routes.historyWithdraw, component: HistoryWithdraw },
    { path: config.routes.profile, component: Profile },
    { path: config.routes.editProfile, component: EditProfile },
    { path: config.routes.changePass, component: ChangePass },
    { path: config.routes.historyBooking, component: HistoryBooking },
    { path: config.routes.detailBooking, component: DetailBooking },
    { path: config.routes.orders, component: HistoryOrder },
    { path: config.routes.detailOrder, component: DetailOrder },
    // { path: config.routes.cart, component: Cart },
    { path: config.routes.checkOut, component: CheckOutOrder },
    { path: config.routes.doubleCheckOut, component: DoubleCheckOutOrder },
    { path: config.routes.card, component: MyCard },
    { path: config.routes.useCard, component: MyUseCard },
    { path: config.routes.useCardDetail, component: MyUseCardDetail },
    { path: config.routes.checkOutComboService, component: CheckOutComboService },
    { path: config.routes.doubleCheckOutComboService, component: DoubleCheckOutComboService },
    { path: config.routes.downLineCollab, component: DownLineCollab },
    { path: config.routes.shareCollab, component: ShareCollab },
    { path: config.routes.notification, component: NotificationPage },
    // { path: config.routes.topUpDetail, component: TopUpDetail },
    { path: config.routes.pageNotFound, component: PageNotFound, layout: null },
    { path: config.routes.postDetail, component: PostDetail },
    { path: config.routes.personalPage, component: PersonalPage },
    { path: config.routes.notiDetail, component: NotiDetail },
    { path: config.routes.histotyUseCard, component: HistoryUseCard },
];

export { publicRoutes, privateRoutes };
